import React, { useState } from "react";

const WHATSAPP_NUMBER = "919034132476"; // replace with real number
const INSTAGRAM_URL   = "https://instagram.com/google"; // replace with real handle

export function FloatingContact({ raised = false }: { raised?: boolean }) {
  const [expanded, setExpanded] = useState(false);
  const [hovered, setHovered]   = useState<string | null>(null);

  const waLink = `https://wa.me/${WHATSAPP_NUMBER}?text=Hi%20True%20Value%20Mobiles%2C%20I%20have%20a%20query%20about%20selling%20my%20device.`;

  const buttons = [
    {
      id: "whatsapp",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
          <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2.046 21.9a.5.5 0 00.617.61l4.86-1.557A9.96 9.96 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18a7.96 7.96 0 01-4.075-1.117l-.29-.174-3.007.963.924-2.93-.19-.3A7.96 7.96 0 014 12c0-4.418 3.582-8 8-8s8 3.582 8 8-3.582 8-8 8z"/>
        </svg>
      ),
      color: "#25D366",
      bg: "#25D366",
      label: "Chat on WhatsApp",
      href: waLink,
      external: true,
    },
    {
      id: "instagram",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
        </svg>
      ),
      color: "#E1306C",
      bg: "linear-gradient(45deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888)",
      label: "Follow on Instagram",
      href: INSTAGRAM_URL,
      external: true,
    },
  ];

  return (
    <>
      {/* Backdrop when expanded on mobile */}
      {expanded && (
        <div
          onClick={() => setExpanded(false)}
          style={{ position: "fixed", inset: 0, zIndex: 998, background: "transparent" }}
        />
      )}

      <div className={`floating-contact${raised ? " floating-contact-raised" : ""}`} style={{
        position: "fixed",
        bottom: 28,
        right: 24,
        zIndex: 999,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        gap: 12,
      }}>

        {/* Action buttons — slide up when expanded */}
        {buttons.map((btn, i) => (
          <a
            key={btn.id}
            href={btn.href}
            target={btn.external ? "_blank" : undefined}
            rel={btn.external ? "noopener noreferrer" : undefined}
            title={btn.label}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              background: btn.bg,
              color: "#fff",
              borderRadius: 50,
              padding: hovered === btn.id ? "10px 18px 10px 14px" : "10px 14px",
              boxShadow: "0 4px 18px rgba(0,0,0,0.22)",
              textDecoration: "none",
              fontSize: 13,
              fontWeight: 600,
              fontFamily: "var(--font-body)",
              whiteSpace: "nowrap",
              overflow: "hidden",
              maxWidth: hovered === btn.id ? 220 : 46,
              height: 46,
              transition: "all 0.3s cubic-bezier(0.4,0,0.2,1)",
              opacity: expanded ? 1 : 0,
              transform: expanded ? "translateY(0) scale(1)" : `translateY(${(buttons.length - i) * 18}px) scale(0.8)`,
              pointerEvents: expanded ? "auto" : "none",
              transitionDelay: expanded ? `${i * 60}ms` : "0ms",
            }}
            onMouseEnter={() => setHovered(btn.id)}
            onMouseLeave={() => setHovered(null)}
          >
            <span style={{ flexShrink: 0, display: "flex", alignItems: "center" }}>{btn.icon}</span>
            <span style={{
              opacity: hovered === btn.id ? 1 : 0,
              maxWidth: hovered === btn.id ? 160 : 0,
              overflow: "hidden",
              transition: "all 0.25s ease",
              fontSize: 13,
            }}>
              {btn.label}
            </span>
          </a>
        ))}

        {/* Main toggle button */}
        <button
          onClick={() => setExpanded(o => !o)}
          title="Contact us"
          style={{
            width: 54,
            height: 54,
            borderRadius: "50%",
            background: expanded
              ? "var(--text)"
              : "linear-gradient(135deg,#ff6b35,#e85a25)",
            border: "none",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: expanded
              ? "0 4px 18px rgba(0,0,0,0.25)"
              : "0 6px 22px rgba(255,107,53,0.45)",
            transition: "all 0.3s cubic-bezier(0.4,0,0.2,1)",
            transform: expanded ? "rotate(45deg)" : "none",
            flexShrink: 0,
          }}
          onMouseEnter={e => { (e.currentTarget as HTMLElement).style.transform = expanded ? "rotate(45deg) scale(1.08)" : "scale(1.08)"; }}
          onMouseLeave={e => { (e.currentTarget as HTMLElement).style.transform = expanded ? "rotate(45deg)" : "none"; }}
        >
          {expanded ? (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round">
              <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          ) : (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
              <line x1="9" y1="10" x2="15" y2="10" />
              <line x1="9" y1="14" x2="13" y2="14" />
            </svg>
          )}
        </button>

        {/* Pulse ring on main button when collapsed */}
        {!expanded && (
          <div style={{
            position: "absolute",
            bottom: 0,
            right: 0,
            width: 54,
            height: 54,
            borderRadius: "50%",
            border: "2px solid rgba(255,107,53,0.5)",
            animation: "pulse-ring 2.5s ease-out infinite",
            pointerEvents: "none",
          }} />
        )}
      </div>
    </>
  );
}
